'use strict';

const _ = require('lodash');
const Classnames = require('classnames');
const React = require('react');
const Reflux = require('reflux');
const ReactRouter = require('react-router');

const IndexRoute = ReactRouter.IndexRoute;
const Route      = ReactRouter.Route;
const Router     = ReactRouter.Router;
const Link       = ReactRouter.Link;

import { DetectFlex, DetectIE } from '../../../../../common-js/helpers';

const isNode = typeof document === 'undefined';
if (!isNode) {
    require('./landing.scss');

    if (!DetectFlex()) {
        var Flexibility = require('flexibility');
    }
}

const Actions = require('../../store').Actions;
const Components = require('../../components');
const Constants = require('../../constants');
const Forms = require('../../forms');
const Global = require('../../global');
const Moma = require('../../plugins/moma/');
const StackableTabs = require('../../plugins/stackable-tabs/');
const Store = require('../../store').Store;

const DeviceImage     = Global.DeviceImage;
const ResponsiveMixin = Global.ResponsiveMixin;

const Tagline = (pros) => {
    return (
        <div className='landing-tagline'>
            {Payload.text['landing.banner.subtitle']}
        </div>
    );
};

const Banner = React.createClass({
    mixins: [ ResponsiveMixin ],

    render: function() {
        return (
            <div className='landing-banner'>
                <DeviceImage src='landing/banner.jpg' alt='Banner image' />

                {this.state.viewportLayout == 'desktop' ?
                    <img src={Constants.static + 'images/landing/logos1.png'} alt="Modern Office Furniture"/>
                : null}

                <div className='landing-banner-captions'>
                    <div>
                        {Payload.text['landing.banner.title']}
                    </div>    
                    <div>
                        {Payload.text['landing.banner.caption']}
                    </div>
                </div>
            </div>
        );
    },
});

const Feature = React.createClass({
    mixins: [ ResponsiveMixin ],

    render: function() {
        const img = (
            <div className='landing-features-featurette-image'>
                <DeviceImage src={`landing/features-${this.props.ix}.png`} />
            </div>
        );
        return (
            <div className='landing-features-featurette' key={this.props.ix}>
                <div /* separate from flex */>
                    {this.state.viewportLayout == 'desktop' ? img : null}
                    
                    <div className='landing-features-featurette-text'>
                        <div className='landing-features-featurette-title'>
                            {Payload.text[`landing.features.${this.props.ix}.title`]}
                        </div>
                        
                        {this.state.viewportLayout != 'desktop' ? img : null}
                        
                        <div className='landing-features-featurette-caption'>
                            {Payload.text[`landing.features.${this.props.ix}.caption`]}
                        </div>
                    </div>
                </div>
            </div>
        );
    },
});

const Features = React.createClass({
    componentDidMount: function() {
        if (Flexibility) {
            Flexibility(this.refs.flex);
        }
    },
    render: function() {
        if (DetectIE) {
            var ie = DetectIE();
        }

        var classes = Classnames({
            'landing-features-flex': true,
            'detect-ie': ie !== false && ie <= 10,
        });
        return (
            <div className='landing-features'>
                <div className='landing-features-title'>
                    {Payload.text['landing.features.title']}
                </div>
                <div className={classes} data-style='display: flex;' ref='flex'>
                    {_.times(4, (ix) => {
                        return (
                            <Feature ix={ix} key={ix} />
                        );
                    })}
                </div>
            </div>
        );
    },
});

const Gallery = React.createClass({
    render: function() {
        const urlkey = this.props.urlkey ? this.props.urlkey : 'office-furniture-desk';
        const gallerySpec = {
            desktop: {
                position: 'inside',
                graphic: 'solid',
                navigation: 'hero',
            },
            mobile: {
                position: 'inside',
                graphic: 'simple',
                navigation: 'hero',
            },
        };
        const gallery = <CollectionSampleGallery spec    = {gallerySpec}
                                                 gallery = {Payload.extra.gallery[urlkey].items} />
        const tabs = _.map(Payload.extra.gallery, (gallery, urlkey) => {
            return {
                title:   gallery.title,
                url:     '/full-service-overview/' + urlkey,
            };
        });

        return (
            // Date.now() forces reset of child components, i.e. MomaTrack's cache gets cleared
            <div className='landing-gallery' key={Date.now()}>
                <div className='landing-gallery-title'>
                    <div className='landing-gallery-title-h1'>
                        {Payload.text['landing.gallery.title']}
                    </div>
                    <p>
                        {Payload.text['landing.gallery.caption']}
                    </p>
                </div>
                <StackableTabs root     = '/full-service-overview'
                               location = {this.props.location}
                               content  = {gallery}
                               tabs     = {tabs}
                               theme    = 'landing' />
            </div>
        );
    }
});

const CollectionSampleGallery = React.createClass({
    mixins: [ Moma, ResponsiveMixin ],

    AssetSizes: function() {
        return {
            desktop: {
                width: Constants.Breaks.DesktopWidth,
                height: 418,
            },
            mobile: {
                portrait: {
                    width: 500,
                    height: 222,
                },
                landscape: {
                    width: 750,
                    height: 275,
                },
            },
        };
    },
    slideContent: function(slide) {
        return (
            <div className='landing-gallery-slide'>
                <img src={Payload.release.media + slide.image} className='fo-tabBody-gallery-image' alt="Modern Office Furniture"/>
                <div className='landing-gallery-slide-itemID'>
                    Item {slide.id}
                </div>
            </div>
        );
    }    
});

const Logos2 = (props) => {
    return (
        <div className='landing-logos2'>
            <div className='landing-logos2-title'>
                {Payload.text['landing.logos2.title']}
            </div>
            <img src={Constants.static + 'images/landing/logos2.jpg'} alt="Modern Office Furniture"/>
        </div>
    );
};

const Testimonials = React.createClass({
    mixins: [ ResponsiveMixin ],

    render: function() {
        const vimeoID = '183063291';
        const src = `//player.vimeo.com/video/${vimeoID}?badge=0&amp;byline=0&amp;title=0`;
        return (
            <div className='landing-testimonials'>
                <div className='landing-testimonials-title'>
                    {Payload.text['landing.testimonials.title']}
                </div>
                <div className='landing-testimonials-video'>
                    <iframe src             = {src}
                            width           = "100%"
                            height          = {this.state.viewportLayout == 'desktop' ? 400 : null}
                            frameBorder     = "0"
                            allowFullScreen = "" 
                            title           = "Vimeo player"
                            />
                </div>
                <div className='landing-testimonials-paragraph' dangerouslySetInnerHTML={{ __html: Payload.text['landing.testimonials.desc'] }} />
            </div>
        );
    },
});

const Contact = React.createClass({
    mixins: [ ResponsiveMixin, Reflux.connect(Store, 'store') ],

    getInitialState: function() {
        return {
            alert: false,
        };
    },
    save: function(keyname, event) {
        Actions.setProjectField(keyname, event.target.value);
    },
    submit: function(event) {
        if (this.refs.clientInfo.validate()) {
            Actions.submit('landing');  // redirects
        } else {
            this.setState({
                alert: true  // pressing submit shows all required fields
            });
            alert('Fields with a red border are required');
            // this.refs.error.open('Fields with a red border are required');
        }
    },
    render: function() {
        return (
            <div className='landing-contact'>
                <div className='landing-contact-title'>
                    {Payload.text['landing.contact.title']}
                </div>
                <div className='landing-contact-segment'>
                    <div className='landing-contact-left'>
                        <div className='landing-contact-call'>
                            <img src={Constants.static + 'images/contact/phone@2x.png'} />
                            <div className='landing-contact-call-title'>
                                {Payload.text['landing.contact.callus']}
                            </div>
                            <div className='landing-contact-call-number'>
                                <a href={`tel:${Payload.header.text['header.phone.domestic.machine-readable']}`} id='hd-phone'>
                                    {Payload.header.text['header.phone.domestic.human-readable']}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='landing-contact-sep'>

                        <svg version="1.1" baseProfile="full" width="40" height="470" xmlns="http://www.w3.org/2000/svg">
                            <line x1="20" y1="0" x2="20" y2="414" />
                            <g transform="translate(0, 180)">
                                <rect width="40" height="80" />
                                <g transform="translate(0, 20)">
                                    <circle cx="20" cy="20" r="20" />
                                    <text x="0" y="0" transform="translate(20, 25)" textAnchor="middle">
                                        OR
                                    </text>
                                </g>
                            </g>
                        </svg>

                    </div>
                    <div className='landing-contact-right'>
                        <Components.ContactForm.EssentialDetails alert   = {this.state.alert}
                                                                 ref     = 'clientInfo' 
                                                                 compact = {true} />
                        <div className='landing-contact-desc'>
                            <Components.ContactForm.DescriptionField />
                        </div>
                        <div className='landing-contact-submit'>
                            <Forms.Button type    = 'submit'
                                          label   = 'REQUEST A CONSULTATION'
                                          onClick = {this.submit} />
                        </div>
                    </div>
                </div>
                {/*<Global.SimpleDialog ref='error' />*/}
            </div>
        );
    },
});

const Landing = React.createClass({
    mixins: [ ResponsiveMixin ],

    render: function() {
        return (
            <div className='landing'>
                <Tagline />
                <Banner />
                <Features />
                <Gallery location={this.props.location} urlkey={this.props.params.gallery} />
                {this.state.viewportLayout == 'desktop' ?
                    <Logos2 />
                : null}
                <Testimonials />
                <Contact />
            </div>
        );
    }
});

module.exports = (
    <Route component={Landing} path='/full-service-overview(/:gallery)' onEnter={Global.GAPageview} />
);



// WEBPACK FOOTER //
// ./src/pages/content/landing.jsx